import { render, staticRenderFns } from "./mimesis.vue?vue&type=template&id=3bfe0aab"
import script from "./mimesis.vue?vue&type=script&lang=js"
export * from "./mimesis.vue?vue&type=script&lang=js"
import style0 from "./mimesis.vue?vue&type=style&index=0&id=3bfe0aab&prod&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports